import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { SabisComponents2Module } from "../sabis-components2.module";
import { SabisNgxDialogModule } from "../sabis-dialog/sabis-dialog.module";
import { SabisNgxNotificationDialogComponent } from "./notification-dialog/notification-dialog.component";


@NgModule({
  declarations: [
    SabisNgxNotificationDialogComponent
  ],
  imports: [
    CommonModule,

    SabisComponents2Module,
    SabisNgxDialogModule
  ],
  exports: [
    SabisNgxNotificationDialogComponent
  ]
})
export class SabisNgxNotificationsModule { }
